import PropTypes from 'prop-types'
import { Skeleton } from 'antd'
import { createUseStyles } from 'react-jss'
import { MOBILE_MEDIA_QUERY, TABLET_MEDIA_QUERY } from '../../lib/responsive'

const useStyles = createUseStyles({
  root: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  hero: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 12,
    flexWrap: 'wrap',
  },
  heroText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    flex: '1 1 auto',
    minWidth: 0,
  },
  heroStats: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  todoPanel: {
    borderRadius: 8, // antd borderRadiusLG
    padding: '10px 14px',
    border: '1px solid #e2e8f0',
    background: '#f8fafc',
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    flexWrap: 'wrap',
    marginBottom: 14,
  },
  todoItems: {
    display: 'flex',
    gap: 6,
    flex: 1,
    flexWrap: 'wrap',
  },
  divider: {
    width: 1,
    height: 20,
    background: 'rgba(15,23,42,0.08)',
    flexShrink: 0,
  },
  grid: {
    display: 'grid',
    gap: 14,
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    // Keep in sync with the real dashboard grid so the layout does not jump.
    [TABLET_MEDIA_QUERY]: {
      gridTemplateColumns: '1fr',
    },
    [MOBILE_MEDIA_QUERY]: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    background: '#fff',
    padding: '16px 20px',
    // Igual que la tarjeta real del dashboard, o el layout salta al resolver.
    borderRadius: 8, // antd borderRadiusLG
    border: '1px solid #f0f0f0', // antd colorBorderSecondary
    minHeight: 360,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  chartArea: {
    marginTop: 8,
  },
})

export default function DashboardSkeleton({ isAdmin = false }) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <style>{`
        .ant-layout-content {
          background: transparent !important;
        }
      `}</style>
      <div className={classes.hero}>
        <div className={classes.heroText}>
          <Skeleton.Input active size="small" style={{ width: 220, height: 24 }} />
          <Skeleton.Input active size="small" style={{ width: 320, height: 14 }} />
        </div>
        <div className={classes.heroStats}>
          <Skeleton.Button active style={{ width: 120, height: 34, borderRadius: 6 }} />
          {isAdmin && (
            <Skeleton.Button active style={{ width: 120, height: 34, borderRadius: 6 }} />
          )}
          <Skeleton.Button active shape="circle" size="small" />
        </div>
      </div>

      <div className={classes.todoPanel}>
        <Skeleton.Input active size="small" style={{ width: 90, height: 18 }} />
        <div className={classes.divider} />
        <div className={classes.todoItems}>
          <Skeleton.Button active style={{ width: 180, height: 30, borderRadius: 6 }} />
          <Skeleton.Button active style={{ width: 200, height: 30, borderRadius: 6 }} />
          <Skeleton.Button active style={{ width: 160, height: 30, borderRadius: 6 }} />
        </div>
      </div>

      <div className={classes.grid}>
        {[0, 1, 2].map(key => (
          <div key={key} className={classes.card}>
            <div className={classes.cardHeader}>
              <Skeleton.Input active size="small" style={{ width: 140, height: 18 }} />
              <Skeleton.Button active size="small" style={{ width: 64, borderRadius: 6 }} />
            </div>
            <div className={classes.chartArea}>
              <Skeleton active paragraph={{ rows: 6, width: ['90%', '100%', '85%', '95%', '80%', '70%'] }} title={false} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

DashboardSkeleton.propTypes = {
  isAdmin: PropTypes.bool,
}
